import {
  ADD_REVIEW_SET_STAR_RATING,
  ADD_REVIEW_REVIEW_CHANGE,
  ADD_REVIEW_SUBMIT_STATUS,
  ADD_REVIEW_RESPONSE_RECEIVED,
  ADD_REVIEW_SET_STATE,
  ADD_REVIEW_SET_COPY_STATUS,
  ADD_REVIEW_ERROR,
  ADD_REVIEW_SET_GOOGLE_ID,
  ADD_REVIEW_SET_RECOMMENDED_VALUE,
} from '../constants/index';

const setStarRating = (value: any) => ({
  type: ADD_REVIEW_SET_STAR_RATING,
  payload: { value },
});

const setReview = (value: any) => ({
  type: ADD_REVIEW_REVIEW_CHANGE,
  payload: { value },
});

const setSubmissionStatus = (value: any) => ({
  type: ADD_REVIEW_SUBMIT_STATUS,
  payload: { value },
});

const responseReceived = () => ({
  type: ADD_REVIEW_RESPONSE_RECEIVED,
  payload: { value: true },
});

const responseError = (value: any) => ({
  type: ADD_REVIEW_ERROR,
  payload: { value },
});

const setReviewFlowState = (value: any) => ({
  type: ADD_REVIEW_SET_STATE,
  payload: { value },
});

const setGooglePlaceUrl = (value: any) => ({
  type: ADD_REVIEW_SET_GOOGLE_ID,
  payload: { value },
});

const setCopyStatus = (value: any) => ({
  type: ADD_REVIEW_SET_COPY_STATUS,
  payload: { value },
});

const setHasRecommendedValue = (value: any) => ({
  type: ADD_REVIEW_SET_RECOMMENDED_VALUE,
  payload: { value },
});

export {
  setGooglePlaceUrl,
  setStarRating,
  setReview,
  setSubmissionStatus,
  responseReceived,
  setReviewFlowState,
  setCopyStatus,
  responseError,
  setHasRecommendedValue,
};
